module.exports = __webpack_public_path__ + "img/dashboard-landing-improve-workflow.323f5122.svg";